<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >在线文档</span>
      <!-- <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >测试工具</span> -->
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";


import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'
const apiUrlTest = 'order/getOrders';
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: "查询新增订单接口创建的订单",
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: "接入方在平台的api账户标识",},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: "签名字符串",},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: "时间戳，毫秒",},
                    ]
            },
             { 
                title:'请求参数', 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: "业务参数",describe: "业务参数模块内json格式的string类型",},
                ]
            },
             {
              title:"业务参数",
              value:[
                {name: "customerCode",type: "String(30)",require: "Y",normal: "J0086474299",describe: "客户编码（联系出货网点提供）"},
                {name: "digest",type: "String(50)",require: "Y",normal: "明文密码:H5CD3zE6",describe: "签名，Base64(Md5(客户编号+密文+privateKey))，其中密文：MD5(明文密码+jadada236t2) 后大写"},
                {name: "command",type: "int(5)",require: "Y",normal: "",describe: "查询命令 1.按客户订单编号查询   2.按运单编号查询（用运单号查订单状态）   3.按下单时间段查询（查订单）（按时间段查询返回不限制条数）  4.订单编号"},
                {name: "serialNumber",type: "List[]",require: "N",normal: "",describe: "command=1 客户订单编号查询 ;command=2 运单编号暂时;command=4订单号（公司内部）支持200个; Command=1、2或3时必填"},
            
                {name: "startDate",type: "String(30)",require: "N",normal: "",describe: "开始时间(24小时制: yyyy-MM-dd HH:mm:ss)（command为3时必填）（客户下单时间）command = 3 时必填"},
                {name: "endDate",type: "String(30)",require: "N",normal: "",describe: "结束时间(24小时制: yyyy-MM-dd HH:mm:ss)（command为3时必填），时间范围最大7天command = 3 时必填"},
                {name: "status",type: "int(10)",require: "N",normal: "",describe: `状态（订单状态取下方状态表，筛选数据使用，默认全部）:已取消 104 ;;已取件 103 ;已调派业务员 102 ;已调派网点 101 ;未调派 100`},
                {name: "current",type: "int",require: "N",normal: "",describe: "command = 3 时必填"},
                {name: "size",type: "int",require: "N",normal: "",describe: "command = 3 时必填"},
              ]
            }
        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:'响应参数',
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: "返回码，见附录"},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: "描述"},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: "业务数据"},
                  ]
            },
            
            {
              title:"data类型说明",
              value:[
                  {name: "lastCenterName",type: "String",require: "N",normal: "",describe: "集包地"},
                  {name: "orderNumber",type: "long",require: "Y",normal: "",describe: "系统订单号"},
                  {name: "txlogisticId",type: "String",require: "Y",normal: "",describe: "客户订单号    客户自己系统的订单号"},
                  {name: "billCode",type: "String",require: "Y",normal: "",describe: "运单号"},
                  {name: "expressType",type: "String",require: "Y",normal: "",describe: "快件类型 标准快递EZ"},
                  {name: "orderStatus",type: "String",require: "Y",normal: "",describe: "订单状态 ：已取消 104 ；已取件 103 ；已调派业务员 102 ；已调派网点 101 ；未调派 100"},
                  {name: "orderType",type: "String",require: "Y",normal: "",describe: "订单类型  ：01散客  02月结"},
                  {name: "serviceType",type: "String",require: "Y",normal: "",describe: "服务类型  02 门店寄件  01 上门取件"},
                  {name: "deliveryType",type: "String",require: "Y",normal: "",describe: "派送类型 : 06 代收点自提; 05 快递柜自提; 04 站点自提; 03 派送上门"},
                  {name: "sortingCode",type: "String",require: "Y",normal: "",describe: "三段码"},
                  {name: "sumFreight",type: "String",require: "N",normal: "",describe: "参考总运费（数值型）"},
                  {name: "sender",type: "Object",require: "Y",normal: "",describe: "寄件信息对象"},
                  {name: "receiver",type: "Object",require: "Y",normal: "",describe: "收件信息对象"},

                  {name: "sendStartTime",type: "String",require: "N",normal: "",describe: "物流公司上门取货开始时间 yyyy-MM-dd HH:mm:ss"},
                  {name: "sendEndTime",type: "String",require: "N",normal: "",describe: "客户物流公司上门取货结束时间 yyyy-MM-dd HH:mm:ss编号"},
                  {name: "goodsType",type: "String",require: "Y",normal: "",describe: "物品类型（对应订单主表物品类型）:<p>bm000001 文件</p>  <p>bm000002 数码产品</p>  <p>bm000003 生活用品</p>  <p>bm000004  食品</p>  <p>bm000005  服饰</p>  <p>bm000006  其他</p>  <p>bm000007 生鲜类</p>  <p>bm000008 易碎品</p><p>bm000009 液体</p>"},
                  {name: "length",type: "int",require: "N",normal: "",describe: "长，cm编号"},
                  {name: "width",type: "int",require: "N",normal: "",describe: "宽，cm"},
                  {name: "height",type: "int",require: "N",normal: "",describe: "高，cm"},
                  {name: "volume",type: "int",require: "N",normal: "",describe: "体积"},
                  {name: "weight",type: "int",require: "Y",normal: "",describe: "重量（不能为负数）"},
                  {name: "totalQuantity",type: "int",require: "N",normal: "默认1",describe: "包裹总件数"},
                  {name: "itemsValue",type: "String",require: "N",normal: "",describe: "代收货款金额 (数值型)"},
                  {name: "priceCurrency",type: "String",require: "N",normal: "",describe: "代收货款币别（默认本国币别，如：RMB）"},
                  {name: "offerFee",type: "String",require: "N",normal: "",describe: "保价金额(数值型)，单位：元"},
                  {name: "remark",type: "String",require: "N",normal: "",describe: "备注"},
                  {name: "items",type: "List",require: "N",normal: "",describe: "商品信息列表"},
                  {name: "createOrderTime",type: "String",require: "Y",normal: "",describe: "订单创建时间 yyyy-MM-dd HH:mm:ss"}
                ]
            },
            
            {
              title:"sender类型说明",
              value:[
                {name: "name",type: "String(32)",require: "Y",normal: "",describe: "寄件人姓名"},
                {name: "company",type: "String(100)",require: "N",normal: "",describe: "寄件公司"},
                {name: "postCode",type: "String(32)",require: "N",normal: "",describe: "寄件邮编"},
                {name: "mailBox",type: "String(150)",require: "N",normal: "",describe: "寄件邮箱"},
                {name: "mobile",type: "String(30)",require: "Y",normal: "",describe: "寄件手机（手机和电话二选一必填）"},
                {name: "phone",type: "String(30)",require: "Y",normal: "",describe: "寄件电话（手机和电话二选一必填）"},
                {name: "countryCode",type: "String(20)",require: "Y",normal: "CHN",describe: "寄件国家三字码（如：中国=CHN、印尼=IDN）"},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe: "寄件省份"},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: "寄件城市"},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe: "寄件区域"},
                {name: "town",type: "String(32)",require: "N",normal: "",describe: "寄件乡镇"},
                {name: "street",type: "String(32)",require: "N",normal: "",describe: "寄件街道"},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe: "寄件详细地址"}
              ]
            },
            {
              title:"receiver类型说明",
              value:[
                {name: "name",type: "String(32)",require: "Y",normal: "",describe: "收件人姓名"},
                {name: "company",type: "String(100)",require: "N",normal: "",describe: "收件公司"},
                {name: "postCode",type: "String(32)",require: "N",normal: "",describe: "收件邮编"},
                {name: "mailBox",type: "String(150)",require: "N",normal: "",describe: "收件邮箱"},
                {name: "mobile",type: "String(30)",require: "Y",normal: "",describe: "收件手机（手机和电话二选一必填）"},
                {name: "phone",type: "String(30)",require: "Y",normal: "",describe: "收件电话（手机和电话二选一必填）"},
                {name: "countryCode",type: "String(20)",require: "Y",normal: "CHN",describe: "收件国家三字码（如：中国=CHN、印尼=IDN）"},
                {name: "prov",type: "String(32)",require: "Y",normal: "",describe: "收件省份"},
                {name: "city",type: "String(32)",require: "Y",normal: "",describe: "收件城市"},
                {name: "area",type: "String(32)",require: "Y",normal: "",describe: "收件区域"},
                {name: "town",type: "String(32)",require: "N",normal: "",describe: "收件乡镇"},
                {name: "street",type: "String(32)",require: "N",normal: "",describe: "收件街道"},
                {name: "address",type: "String(150)",require: "Y",normal: "",describe: "收件详细地址"}
              ]
            },
            {
              title:"items类型说明",
              value:[
                {name: "itemType",type: "String(30)",require: "N",normal: "",describe: "物品类型: <p>bm000001 文件</p>  <p>bm000002 数码产品</p>  <p>bm000003 生活用品</p>  <p>bm000004  食品</p>  <p>bm000005  服饰</p>  <p>bm000006  其他</p>  <p>bm000007 生鲜类</p>  <p>bm000008 易碎品</p><p>bm000009 液体</p>"},
                {name: "itemName",type: "String(30)",require: "N",normal: "",describe: "物品名称"},
                {name: "chineseName",type: "String(60)",require: "N",normal: "",describe: "物品中文名称"},
                {name: "englishName",type: "String(60)",require: "N",normal: "",describe: "物品英文名称"},
                {name: "number",type: "int(4)",require: "N",normal: "",describe: "件数，≤1"},
                {name: "itemValue",type: "String(20)",require: "N",normal: "",describe: "申报价值(数值型)"},
                {name: "priceCurrency",type: "String(20)",require: "N",normal: "",describe: "申报货款币别（默认本国币别，如：RMB）"},
                {name: "desc",type: "String(100)",require: "N",normal: "",describe: "物品描述"},
                {name: "itemUrl",type: "String(100)",require: "N",normal: "",describe: "商品URL"}
              ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {
      "serialNumber":["1598516207047"],
      "digest":"x+naV5ZQWEddcrRlxjX04Q==",
      "customerCode":"J0086093125",
      "command":1
      }`,
        //返回示例
        responseCode: JSON.parse(
          `{
    "code": "1",
    "msg": "success",
    "data": [
        {
            "countryCode": null,
            "customerId": "1598516207047",
            "txlogisticId": null,
            "billCode": "YL1234567890123",
            "expressType": null,
            "orderType": "1",
            "serviceType": null,
            "deliveryType": null,
            "sender": {
                "name": "李白",
                "company": "天美工作室",
                "postCode": "518000",
                "mailBox": "ant_li@qq.com",
                "mobile": "12345678909",
                "phone": "",
                "countryCode": null,
                "prov": "广东省",
                "city": "深圳",
                "area": "南山区",
                "town": "南山区",
                "street": "粤海街道",
                "address": "粤美特大厦"
            },
            "receiver": {
                "name": "高渐离",
                "company": "天美工作室",
                "postCode": "518000",
                "mailBox": "ant_li@qq.com",
                "mobile": "12345678909",
                "phone": "",
                "countryCode": null,
                "prov": "广东省",
                "city": "深圳",
                "area": "南山区",
                "town": "南山区",
                "street": "粤海街道",
                "address": "粤美特大厦"
            },
            "createOrderTime": null,
            "updateOrderTime": null,
            "sendStartTime": null,
            "sendEndTime": "2019-08-06 15:30:00",
            "payType": null,
            "goodsType": null,
            "length": null,
            "width": null,
            "height": null,
            "volume": 250.0,
            "weight": 1.0,
            "totalQuantity": 1,
            "itemsValue": 200.0,
            "priceCurrency": "RMB",
            "offerFee": 200000.0,
            "remark": "重要文件",
            "items": [
                {
                    "id": null,
                    "itemType": "文件",
                    "itemName": null,
                    "chineseName": "文件C",
                    "englishName": "文件E",
                    "number": 1,
                    "itemValue": "200000.00",
                    "priceCurrency": "RMB",
                    "desc": "文件",
                    "itemUrl": null
                }
            ],
            "orderNumber": 26666027030937625,
            "sortingCode": "110  110-120  130",
            "freight": null,
            "success": null,
            "reason": null,
            "sumFreight": "100",
            "orderStatus": null,
            "terminalDispatchCode": null,
            "lastCenterName":"深圳转运中心"
        }
    ]
}`
          ),

       //错误代码提示
        errcodeJson: [{code:'145003031',msg:"业务参数签名失败"},{code:'145003097',msg:"时间范围非法"},{code:'145003102',msg:"页码非法"},{code:'145003098',msg:"超过数据限制"}]
      },


      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"serialNumber":["1598516207047"],"digest":"x+naV5ZQWEddcrRlxjX04Q==","customerCode":"J0086093125","command":1}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
       //错误代码提示
        errcodeJson: [{code:'145003031',msg:"业务参数签名失败"},{code:'145003097',msg:"时间范围非法"},{code:'145003102',msg:"页码非法"},{code:'145003098',msg:"超过数据限制"}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>